import { get, post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getPdfs = async (page, pageSize) => {
  const builder = new UrlBuilder(`/admin/pdfs/get-pdfs`);

  builder.add('pageNumber', page);
  builder.add('perPage', pageSize);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const addPdf = async (payload) => {
  const builder = new UrlBuilder(`/admin/pdfs/add-pdf`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updatePdf = async (payload) => {
  const builder = new UrlBuilder(`/admin/pdfs/update-pdf`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
